import { render, staticRenderFns } from "./CPMoney.vue?vue&type=template&id=9022d3cc&"
import script from "./CPMoney.vue?vue&type=script&lang=ts&"
export * from "./CPMoney.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports